import React from "react";
import { connect } from "react-redux";
import { normalizeMoney, formatDate } from "../utility";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { formValueSelector, reduxForm, Field, change } from "redux-form";
import transactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import * as agent from "../agent";
import { MaterialTextField } from "./MaterialInput";
import PrintLink from './PrintLink';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const TransactionForm = connect(
    (state, props) => {
        const { repaySum, operations } = props;
        const repayOperation = operations.find(o => o.alias === "CONTRACT_REPAY") || {};
        const { mustHaveContract, mustHaveDepartment } = repayOperation;
        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            mustHaveContract,
            mustHaveDepartment,
            initialValues: {
                manager: state.common.user.id,
                paymentDate: formatDate(new Date()),
                operation: repayOperation._id,
                sum: normalizeMoney(repaySum),
                vat: 0
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

class repayContract extends React.Component {

    state = {
        printed: false,
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
    };

    componentWillMount = () => {
        const { isJur } = this.props;
        agent.User.managers(isJur)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showingModal: true})
    }
    changeSum = (e) => {
        const { contract: {programDetails: {sum} = {}} } = this.props;
        this.setState({ printed: false});
        this.props.changeFieldValue("newSum", normalizeMoney(sum - Number((e.target.value).replace(/\s/g,``))));
    }
    setPrintFlag = () => this.setState({ printed: true})
    dropPrintFlag = () => this.setState({ printed: false})
    handleClose = () => this.setState({ showingModal: false})
    addTransaction = (data) => {
        const { transactions, operations } = this.state;
        const { repaySum } = this.props;
        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions });
        const repayOperation = operations.find(o => o.alias === "CONTRACT_REPAY") || {};
        const transactionsSum = updTransactions.reduce((p, n) => p + +(n.operation === repayOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        this.props.dispatch(change("transaction-form", "sum", normalizeMoney(Math.max(repaySum - transactionsSum, 0))));
    }
    deleteTransaction = (index) => {
        const { transactions } = this.state;
        this.setState({ transactions: transactions.filter((_, i) => i !== index) })
    }

    render() {
        const { manager, contract: {_id, programDetails: {sum, programType} = {}}, repaySum, onContractRepay, handleSubmit } = this.props;
        const { showingModal,
                transactions,
                printed,
                managersLoaded,
                managers,
                counterparties,
                counterpartiesLoaded,
                accounts,
                accountsLoaded,
                operations,
                operationsLoaded } = this.state;
        const isLeasing = programType === "PTS_LEASING";
        const repayOperation = operations.find(o => o.alias === "CONTRACT_REPAY") || {};
        const repayTransactions = transactions.filter(t => t.operation === repayOperation._id);
        const transactionsSum = transactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const newSum = sum - repaySum;
        const submitDisabled = (repaySum === transactionsSum && repaySum < sum);

        const processTransactions = () => transactions.map(t => Object.assign({...t}, {sum: Number(t.sum.replace(/\s/g,``))}));

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form className="common-form common-column">
                    <Field component={MaterialTextField}
                           disabled={true}
                           format={normalizeMoney}
                           endAdornment="₽"
                           name="sum"
                           label="Сумма займа" />
                    <Field component={MaterialTextField}
                           normalize={normalizeMoney}
                           onChange={this.changeSum}
                           endAdornment="₽"
                           name="repay"
                           label="Сумма уменьшения" />
                    <Field component={MaterialTextField}
                           disabled={true}
                           format={normalizeMoney}
                           endAdornment="₽"
                           name="newSum"
                           label="Итого" />
                    {isLeasing ? 
                        <PrintLink href={agent.src.printLT("extra3", _id, manager, newSum)}
                                   action={this.setPrintFlag}
                                   label="Доп. соглашение" />
                        : 
                        <PrintLink href={agent.src.printNew("change_contract", _id, newSum)}
                                   action={this.setPrintFlag}
                                   label="ДКП" />
                    }
                    <PrintLink href={agent.src.printNew("change_order", _id, newSum)}
                               action={this.setPrintFlag}
                               label="Расходный ордер" />
                    <Button type="submit"
                            fullWidth
                            color="primary"
                            onClick={this.handleClick}
                            disabled={!printed}
                            title={printed ? "" : "Распечатайте договор"}
                            size="large"
                            variant="contained" >Погасить займ</Button>
                    <Dialog maxWidth={false} open={showingModal} onClose={this.handleClose}>
                        <Paper className="common-paper">
                            <Grid container justify="center" spacing={16}>
                                <Grid item className="common-column">
                                    <TransactionForm allowedOperations={["CONTRACT_REPAY"]}
                                                      contractMode={true}
                                                      addTransaction={this.addTransaction}
                                                      managersLoaded={managersLoaded}
                                                      managers={managers}
                                                      accounts={accounts}
                                                      accountsLoaded={accountsLoaded}
                                                      counterparties={counterparties}
                                                      counterpartiesLoaded={counterpartiesLoaded}
                                                      operations={operations}
                                                      operationsLoaded={operationsLoaded}
                                                      repaySum={repaySum}
                                                      contractId={_id} />
                                </Grid>
                                <Grid item className="maxwide-column">
                                    <Typography>*Для уменьшения займа необходимо провести одну или несколько транзакций на указанную сумму {normalizeMoney(repaySum)} ₽</Typography>
                                    <Typography>Вы добавили {repayTransactions.length} операций уменьшения займа на сумму {normalizeMoney(transactionsSum)} ₽</Typography>
                                    {repaySum >= sum && <Typography >Cумма уменьшения займа не может превышать всю сумму займа. Для закрытия займа воспользуйтесь соответствующей вкладкой</Typography>}
                                    {repaySum < sum && transactionsSum > repaySum && <Typography >Сумма транзакций превышает сумму уменьшения займа на {normalizeMoney(transactionsSum - repaySum)} ₽. Удалите одну или несколько транзакций уменьшения займа</Typography>}
                                    {repaySum < sum && transactionsSum < repaySum && <Typography >Cумма уменьшения займа превышает сумму транзакций на {normalizeMoney(repaySum - transactionsSum)} ₽. Добавьте одну или несколько транзакций уменьшения займа</Typography>}
                                    {repaySum < sum && transactionsSum === repaySum && <Typography >Cумма уменьшения займа и сумма транзакций совпадают. Операция может быть проведена</Typography>}
                                    <Typography>Чтобы изменить сумму уменьшения займа закройте диалоговое окно</Typography>
                                    { transactions.length > 0 ?
                                        <TransactionTable transactions={transactions}
                                                           accounts={accounts}
                                                           counterparties={counterparties}
                                                           operations={operations}
                                                           onTransactionDelete={this.deleteTransaction} />
                                        :
                                        <Typography>Необходимо добавить транзакцию</Typography>
                                    }
                                </Grid>
                            </Grid>
                            <Grid container spacing={16}>
                                <Grid item className="common-column">
                                    <Button type="submit"
                                            onClick={handleSubmit((data) => {
                                                onContractRepay(_id, sum, data, processTransactions(transactions));
                                                this.handleClose();
                                            })}
                                            fullWidth
                                            color="primary"
                                            disabled={!submitDisabled}
                                            size="large"
                                            variant="contained" >Займ погашен</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Dialog>
                </form>
            </Paper>
        );
    }
}

const RepayContract = connect(
    (state, props) => {
        const { contract: {programDetails: {sum} = {}} } = props;
        const repaySum = Number(`${formValueSelector("contract-repay-form")(state, "repay")}`.replace(/\s/g,``));
        return {
            repaySum,
            manager: state.common.user.id,
            initialValues: {
                sum,
                repay: 0,
                newSum: sum
            }
        };
    },
    dispatch => ({
        changeFieldValue: (field, value) =>
            dispatch(change("contract-repay-form", field, value))
    })
)(reduxForm({ form: "contract-repay-form", enableReinitialize: true })(repayContract));

export default RepayContract;



// WEBPACK FOOTER //
// ./src/components/RepayContract.js